import { observer } from "mobx-react";
import moment from "moment";
import * as React from "react";
import styled from "styled-components";

import DetailsPageFields, {
  FieldType as DetailsField,
} from "@client/components/modules/DetailsPage/Fields";
import StatusPill from "@client/components/ui/StatusPill";
import Style from "@client/utils/Style";
import { Customer } from "@typings/Customer";
import { TokenInfo } from "@typings/Identity";
import {
  Licence,
  LICENCE_VERSION_LABELS,
  normalizeLicenceVersion,
} from "@typings/Licence";
import { Tag } from "@typings/Tag";

const TagWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

type Props = {
  customer: Customer | null;
  tag: Tag | null;
  licence: Licence | null;
  tokenInfo: TokenInfo | null;
};

@observer
class DetailsFields extends React.Component<Props> {
  renderTagDropdown() {
    const tag = this.props.tag;
    return (
      <TagWrapper>
        <StatusPill
          label={tag ? tag.name : "No tag"}
          backgroundColor="white"
          fontColor={Style.palette.primary}
          borderColor={Style.palette.primary}
        />
      </TagWrapper>
    );
  }

  render() {
    const { customer, licence } = this.props;

    const fields: DetailsField[] = [
      {
        label: "Description",
        value: licence?.description,
      },
      {
        label: "Customer",
        value: customer?.name,
        link: customer ? `/customers/${customer.id}` : null,
      },
      {
        label: "Tag",
        value: this.renderTagDropdown(),
        showOnNull: true,
      },
      {
        label: "Installation ID",
        value: licence?.installation_id,
      },
      {
        label: "Licence Edition",
        value:
          LICENCE_VERSION_LABELS[normalizeLicenceVersion(licence?.version)],
      },
      {
        label: "ID",
        value: licence?.id,
      },
      {
        label: "Start Date",
        value: licence?.start_date
          ? moment.utc(licence?.start_date).format("DD MMM YYYY HH:mm")
          : "-",
      },
      {
        label: "End Date",
        value: licence?.end_date
          ? moment.utc(licence.end_date).format("DD MMM YYYY HH:mm")
          : "-",
      },
      {
        label: "Duration",
        value: licence?.duration ? `${licence?.duration} days` : "-",
      },
      {
        label: "VM Replicas",
        value: `${licence?.replicas} VM Replicas`,
      },
      {
        label: "VM Migrations",
        value: `${licence?.migrations} VM Migrations`,
      },
      {
        label: "Created at",
        value: moment(licence?.created_at).format("DD MMM YYYY HH:mm"),
      },
      {
        label: "Created By",
        value: licence?.created_by,
      },
      ...(licence?.tag === "Production" && licence?.support
        ? [
            {
              label: "Coriolis Support",
              value: licence.support,
            },
          ]
        : []),
    ];

    return <DetailsPageFields fields={fields} />;
  }
}

export default DetailsFields;
